import React from "react";
import { useSdkContext } from "~/components/contexts";
import { useNewsletterContext } from "~/components/newsletter/newsletter-widget/contexts";
import { getNewsletterTitle } from "~/components/newsletter/newsletter-widget/sign-up-newsletter/helpers";
import SvgGlobalImpact from "./img-global-impact.svg";
import SvgLunar from "./img-lunar.svg";
import SvgPostMag from "./img-post-mag.svg";
import SvgThisWeekInAsia from "./img-twia.svg";
import { StyledSvgIconEnvelope } from "./styles";
export const ArticleThemeTitle = () => {
  var _newsletterItemForDis;
  const {
    config
  } = useSdkContext();
  const {
    newsletterItemForDisplay
  } = useNewsletterContext();
  const newsletterSvgMap = {
    [config.newsletter.globalImpact]: /*#__PURE__*/React.createElement(SvgGlobalImpact, null),
    [config.newsletter.lunar]: /*#__PURE__*/React.createElement(SvgLunar, null),
    [config.newsletter.postMag]: /*#__PURE__*/React.createElement(SvgPostMag, null),
    [config.newsletter.thisWeekInAsia]: /*#__PURE__*/React.createElement(SvgThisWeekInAsia, null)
  };
  const computedNewsletterTitle = getNewsletterTitle(newsletterItemForDisplay);
  const newsletterId = (_newsletterItemForDis = newsletterItemForDisplay === null || newsletterItemForDisplay === void 0 ? void 0 : newsletterItemForDisplay.entityId) !== null && _newsletterItemForDis !== void 0 ? _newsletterItemForDis : "";
  if (newsletterId in newsletterSvgMap) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, newsletterSvgMap[newsletterId], /*#__PURE__*/React.createElement(StyledSvgIconEnvelope, null));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, computedNewsletterTitle);
};
ArticleThemeTitle.displayName = "ArticleThemeTitle";